import { useEffect, useRef } from "react";

import { setActiveSpaceMouseCommandHandler } from "./activeCommand";
import { runSpaceMouseCommand, type SpaceMouseCommandHandlers } from "./applicationCommands";
import { useSpaceMouseCommands } from "./useSpaceMouseCommands";

/** Mount only while a SpaceMouse session is eligible; composing these viewer hooks is not free. */
export function SpaceMouseCommands() {
    const handlers = useSpaceMouseCommands();
    const handlersRef = useRef<SpaceMouseCommandHandlers>(handlers);
    handlersRef.current = handlers;

    useEffect(() => {
        const handler = (commandId: string) => runSpaceMouseCommand(commandId, handlersRef.current);
        setActiveSpaceMouseCommandHandler(handler);
        return () => setActiveSpaceMouseCommandHandler(undefined);
    }, []);

    return null;
}
